"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _theme = require("../../theme");

var _antd = require("antd");

var _excluded = ["tabsOptions", "type", "activeTabColor", "activeColor"];

var _templateObject;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var TabPane = _antd.Tabs.TabPane;
var Tab = (0, _styledComponents.default)(_antd.Tabs)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  .ant-tabs-tab {\n    line-height: 24px;\n    padding: 16px 0;\n    .ant-tabs-tab-btn {\n      color: ", ";\n      text-shadow: none;\n    }\n    &.ant-tabs-tab-active {\n      .ant-tabs-tab-btn {\n        color: ", ";\n      }\n    }\n    .ant-tabs-tab-btn:focus,\n    .ant-tabs-tab-remove:focus,\n    .ant-tabs-tab-btn:active,\n    .ant-tabs-tab-remove:active {\n      color: ", ";\n    }\n  }\n  .ant-tabs-ink-bar {\n    background: ", ";\n  }\n  &.nav-pills {\n    &.ant-tabs {\n      .ant-tabs-nav {\n        &::before {\n          border-bottom: 0;\n        }\n      }\n    }\n    .ant-tabs-ink-bar {\n      display: none;\n    }\n    .ant-tabs-tab {\n      border: 1px solid ", ";\n      background-color: ", ";\n      padding: 13px 20px;\n      font-size: ", ";\n      color: ", ";\n      line-height: 24px;\n      &:first-child {\n        border-radius: 2px 0 0 2px;\n      }\n      &:last-child {\n        border-radius: 0 2px 2px 0;\n      }\n      & + {\n        .ant-tabs-tab {\n          margin-left: 0;\n          border-left: none;\n        }\n      }\n      &.ant-tabs-tab-active {\n        background-color: ", ";\n        .ant-tabs-tab-btn {\n          color: ", ";\n        }\n      }\n    }\n    .ant-tabs-nav {\n      margin-bottom: 24px;\n    }\n  }\n"])), _theme.theme.colors.black_secondary, function (props) {
  return props.activeTabColor;
}, function (props) {
  return props.activeTabColor;
}, function (props) {
  return props.activeTabColor;
}, _theme.theme.colors.grey, _theme.theme.colors.white, _theme.theme.font_size.size_xl, _theme.theme.colors.black_secondary, function (props) {
  return props.activeTabColor;
}, function (props) {
  return props.activeColor;
});

var TabsComponent = function TabsComponent(props) {
  var _props$tabsOptions = props.tabsOptions,
      tabsOptions = _props$tabsOptions === void 0 ? null : _props$tabsOptions,
      _props$type = props.type,
      type = _props$type === void 0 ? "nav-tabs" : _props$type,
      _props$activeTabColor = props.activeTabColor,
      activeTabColor = _props$activeTabColor === void 0 ? "".concat(_theme.theme.colors.blue_primay) : _props$activeTabColor,
      _props$activeColor = props.activeColor,
      activeColor = _props$activeColor === void 0 ? "".concat(_theme.theme.colors.white) : _props$activeColor,
      rest = _objectWithoutProperties(props, _excluded);

  return /*#__PURE__*/_react.default.createElement(Tab, _extends({}, rest, {
    type: type,
    className: "".concat(type),
    activeTabColor: activeTabColor,
    activeColor: activeColor
  }), tabsOptions && tabsOptions.map(function (option) {
    return /*#__PURE__*/_react.default.createElement(TabPane, {
      tab: option.label,
      key: option.key,
      closeIcon: option.closeIcon,
      forceRender: option.forceRender ? option.forceRender : false
    }, option.content);
  }));
};

var _default = TabsComponent;
exports.default = _default;